<template>
  <div id="page" class="container-fluid">
    <div class="alert alert-danger mt-4" role="alert" v-show="showAlert">
      No episodes were found for the specified employer
    </div>
    <div class="row header mx-4 mt-3">
      <div class="col header-row">
        <h1>Episodic Candidates</h1>
      </div>
      <div class="row filter-row mb-1">
          <div class="patient-search-section mr-2">
            <b-input-group class="patient-search-border text-right">
              <b-form-input ref="searchInput"
                            placeholder="Filter (Patient Name or ID)"
                            class="patient-search" v-model="searchTerm">
              </b-form-input>
              <b-input-group-append>
                <button class="btn btn-default patient-search-submit" type="button">
                  <font-awesome-icon icon="search"/>
                </button>
              </b-input-group-append>
            </b-input-group>
          </div>
          <b-form-group class="mr-2" label-class="ml-2" label="Start Date">
            <b-form-datepicker class="orange-border form-control datepicker" :hide-header="true" :value-as-date="true" v-model="fromDate" :date-format-options="{month: 'short', day: 'numeric', year: 'numeric'}"/>
          </b-form-group>
          <b-form-group class="mr-2" label-class="ml-2" label="Start Time">
            <b-form-timepicker class="orange-border form-control" :hide-header="true" v-model="fromTime"/>
          </b-form-group>

          <b-form-group class="mr-2" label-class="ml-2" label="End Date">
            <b-form-datepicker class="orange-border form-control datepicker" :hide-header="true" :value-as-date="true" v-model="toDate" :date-format-options="{month: 'short', day: 'numeric', year: 'numeric'}"/>
          </b-form-group>
          <b-form-group class="mr-2" label-class="ml-2" label="End Time">
            <b-form-timepicker class="orange-border form-control" :hide-header="true" v-model="toTime" offset="-100"/>
          </b-form-group>
      </div>
    </div>
    <div class="container-fluid">
    <div class="row header">
      <div class="col ml-4">
      </div>
      <div class="row text-right mx-3 pb-4">

        <button name="locations" class="btn btn-outline-orange providers-filter" @click.prevent="showingLocationList = !showingLocationList">
          <font-awesome-icon class="orange mr-2" :icon="[ 'fas', 'location-dot' ]"/>Locations
          <b-badge v-show="selectedLocationIds.length > 0" variant="orange">{{ selectedLocationIds.length }}</b-badge>
        </button>

        <button name="providers" class="btn btn-outline-orange providers-filter mr-2" @click.prevent="showingProviderList = !showingProviderList">
          <font-awesome-icon class="orange mr-2" :icon="[ 'fas', 'user-doctor' ]"/>Providers
          <b-badge v-show="selectedProviderIds.length > 0" variant="orange">{{ selectedProviderIds.length }}</b-badge>
        </button>
        <button name="visit-categories" class="btn btn-outline-orange visit-categories-filter mr-2" @click.prevent="showingVisitTypeList = !showingVisitTypeList">
          <font-awesome-icon class="orange mr-2" :icon="[ 'fas', 'notes-medical' ]"/>Visit Categories
          <b-badge v-show="selectedVisitTypeIds.length > 0" variant="orange">{{ selectedVisitTypeIds.length }}</b-badge>
        </button>
        <b-btn @click.stop="employerPopoverShowing = !employerPopoverShowing"
               id="employerId" variant="outline-orange">
          <font-awesome-icon class="orange mr-2" :icon="[ 'far', 'bars-progress' ]"/>Employer / TPA<b-badge v-show="selectedEmployerIds.length > 0" variant="orange" class="ml-2">{{ selectedEmployerIds.length }}</b-badge>
        </b-btn>
        <b-popover :show.sync="employerPopoverShowing"
                   target="employerId" placement="bottomleft" triggers="">
          <b-form-group v-click-outside="hideEmployerPopover" class="status-popover" label="Employer / TPA">
            <b-form-checkbox-group stacked v-model="selectedEmployerIds" name="employerIds" :options="employerOptions">
            </b-form-checkbox-group>
          </b-form-group>
        </b-popover>
      </div>
    </div>
      <div class="row visits-header">
        <div class="col-1">Appointment</div>
        <div class="col-1 pl-4">Status</div>
        <div class="col-2 pl-5">Patient Name</div>
        <div class="col-2 pl-5">Provider</div>
        <div class="col-1">Employer / TPA</div>
        <div class="col-2 pl-5">Visit Category</div>
        <div class="col-1">Location</div>
        <div class="col-2"></div>
      </div>
      <div v-for="visit in candidateVisits.visits" class="row visit-row align-items-center" :key="visit.visitId">
        <div class="column col-1">
          {{ formatAppointmentDate(visit.appointmentStartDate) }}</div>
        <div class="column col-1 pl-4">{{ visit.episodeStatus === 'InEpisode' ? 'In Episode' : visit.episodeStatus }}</div>
        <div class="column col-2 pl-5">
          <a @click.prevent="goToPatientDetail(visit.organizationPatientId)" href="#">{{ visit.lastName +', ' + visit.firstName }}</a>
        </div>
        <div class="column col-2 pl-5">{{ visit.provider ? visit.provider.displayName : 'No Provider Specified' }}</div>
        <div class="column col-1">
        <div v-for="(employer, index) in visit.organizationEmployers" :key="'employer-' + index">
        <div v-if="visit.specialBenefitsInterest === false">{{ formatEmployer(employer) }}<span v-if="index + 1 < visit.organizationEmployers.length">, </span></div>
        <div v-if="visit.specialBenefitsInterest === true">{{ formatEmployer(employer) }} - Benefits Accepted<span v-if="index + 1 < visit.organizationEmployers.length">, </span></div>
        </div>
        </div>
          <div class="column col-2 pl-5">{{ visit.visitTypeName }}</div>
        <div class="column col-1">{{ visit.location ? visit.location.name : 'Location Not Set' }}</div>
        <div class="column col-2 text-right">
          <button v-if="visit.episodeStatus === 'Candidate' || visit.episodeStatus === 'Closed'" class="btn btn-outline-orange m-1 wide-button" @click="newEstimate(visit)">
            <font-awesome-icon class="orange mr-2" :icon="['far','chart-network']"/>New Episode
          </button>
        </div>
      </div>
    </div>
    <div class="alert alert-secondary" role="alert" v-show="candidateVisits.visits && !candidateVisits.visits.length">
      No candidates were found for the specified locations, providers, date range, and visit categories
    </div>
    <visit-type-select @saveVisitTypeIds="visitTypeSelectionChanged"
                       :is-visit-category="true"
                       :selected-visit-type-ids="selectedVisitTypeIds" :visible="showingVisitTypeList"
                       @update:visible="visible => showingVisitTypeList = visible"></visit-type-select>
    <location-select @saveLocationIds="locationSelectionChanged"
                     :selected-location-ids="selectedLocationIds" :visible="showingLocationList"
                     @update:visible="visible => showingLocationList = visible"></location-select>
    <provider-select @saveProviderIds="providerSelectionChanged"
                     :selected-provider-ids="selectedProviderIds" :visible="showingProviderList"
                     @update:visible="visible => showingProviderList = visible"></provider-select>
    <new-episode-modal :patient-id="selectedPatientId"
                       :visible="showingNewEpisodeModal"
                       @estimateCreated="estimateCreated"
                       :bundles="bundles"
                       :employerBenefits="employerBenefits"
                       :employer="employer"
                       @update:visible="visible => showingNewEpisodeModal = visible"></new-episode-modal>
    <loading-modal :visible="showingLoadingModal" :return-focus="$refs.searchInput"
                   @update:visible="visible => showingLoadingModal = visible"></loading-modal>
    <paginator :totalPages="totalPages" :currentPage="currentPage" @update:currentPage="newPage => currentPage = newPage"></paginator>
  </div>
</template>

<script>
  import api from '../services/api'
  import LocationSelect from '../components/LocationSelect.vue'
  import ProviderSelect from '../components/ProviderSelect.vue'
  import moment from 'moment-timezone'
  import Paginator from '../components/Paginator.vue'
  import _ from 'lodash'
  import NewEpisodeModal from '@/components/NewEpisodeModal.vue'
  import LoadingModal from '../components/LoadingModal.vue'
  import AnalyticsMixin from '@/mixins/AnalyticsMixin'
  import VisitTypeSelect from '@/components/VisitTypeSelect.vue'

  export default {
    name: 'BundleCandidates',

    components: { VisitTypeSelect, NewEpisodeModal, ProviderSelect, LocationSelect, Paginator, LoadingModal },

    mixins: [AnalyticsMixin],

    data () {
      return {
        candidateVisits: [],
        filterCandidateVisits: [],
        errors: [],
        selectedProviderIds: [],
        selectedLocationIds: [],
        selectedVisitTypeIds: [],
        showingLocationList: false,
        showingProviderList: false,
        showingVisitTypeList: false,
        fromDate: moment().startOf('day').utc().toJSON(),
        toDate: moment().startOf('day').add(20, 'hour').utc().toJSON(),
        searchTerm: '',
        fromTime: '00:00',
        toTime: '23:59',
        patient: {
          organizationPatientId: 0,
          organizationEmployerId: 0,
          firstName: '',
          lastName: '',
          isSelfPay: false,
          primaryInsurance: '',
          secondaryInsurance: ''
        },
        isLoadingBundles: false,
        employerBenefits: [],
        isLoadingEmployers: false,
        searchDebounceFn: null,
        showingLoadingModal: false,
        selectedPatientId: 0,
        showingNewEpisodeModal: false,
        bundles: [],
        totalPages: 0,
        currentPage: 1,
        pageSize: 20,
        employer: {},
        showAlert: false,
        employerPopoverShowing: false,
        selectedEmployerIds: [],
        employerOptions: [],
        employerIds: []
      }
    },

    watch: {
      fromDate (newValue, oldValue) {
        if (!this.restoringSettings && newValue !== oldValue) {
          this.searchDebounceFn()
        }
      },
      toDate (newValue, oldValue) {
        if (!this.restoringSettings && newValue !== oldValue) {
          this.searchDebounceFn()
        }
      },
      fromTime (newValue, oldValue) {
        if (!this.restoringSettings && newValue !== oldValue) {
          this.searchDebounceFn()
        }
      },
      toTime (newValue, oldValue) {
        if (!this.restoringSettings && newValue !== oldValue) {
          this.searchDebounceFn()
        }
      },

      currentPage (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.loadVisits()
        }
      },

      day (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.searchDebounceFn()
        }
      },

      searchTerm (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.searchDebounceFn()
        }
      },
      selectedEmployerIds (newValue, oldValue) {
        if (!this.restoringSettings && newValue !== oldValue) {
          this.searchDebounceFn()
        }
      }
    },

    computed: {
      fromDateTime () {
        if (this.fromTime) {
          return moment(moment(this.fromDate).format('YYYY/MM/DD') + ' ' + this.fromTime, 'YYYY/MM/DD HH:mm').toDate()
        } else {
          return moment(this.fromDate).toDate()
        }
      },

      toDateTime () {
        if (this.toTime) {
          return moment(moment(this.toDate).format('YYYY/MM/DD') + ' ' + this.toTime, 'YYYY/MM/DD HH:mm').toDate()
        } else {
          return moment(this.toDate).toDate()
        }
      },

      providers () {
        return this.$store.organization.providers
      },
      allProviderIds () {
        return this.providers.map(provider => {
          return provider.providerId
        })
      },
      locations () {
        return this.$store.organization.locations
      },
      allLocationIds () {
        return this.locations.map(location => {
          return location.locationId
        })
      },
      visitTypes () {
        return this.$store.organization.visitTypes
      },
      allVisitTypeIds () {
        return this.visitTypes.map(visitType => {
          return visitType.organizationVisitTypeId
        })
      },
      allEmployerIds () {
        return this.employerIds.map(aEmployer => {
          return aEmployer.organizationEmployerId
        })
      }
    },

    methods: {
      newEstimate (visit) {
        this.isLoadingNewEpisode = true
        this.selectedPatientId = visit.organizationPatientId
        api.get('/Dashboard/Estimate/Patient/' + visit.organizationPatientId + '/CreateData?loadInsuranceFromIntegration=false').then(response => {
          this.trackEvent(this.$options.name, 'Create', 'ResponseTime', response.config.requestDuration)
          this.bundles = response.data.bundles
          this.employer = response.data.employer
          this.employerBenefits = response.data.employerBenefits
          this.isLoadingNewEpisode = false
          if (!this.bundles || this.bundles.length === 0) {
            this.showAlert = true
          } else {
            this.showingNewEpisodeModal = true
          }
        }).catch(error => {
          this.isLoadingNewEpisode = false
          if (!this.$store.canHandleNetworkError(error)) {
            this.$store.logErrorResponse(this.$options.name, 'CreateError', error)
          }
        })
      },

      visitTypeSelectionChanged (selectedIds) {
        this.selectedVisitTypeIds = selectedIds
        this.showingVisitTypeList = false
        this.loadVisits()
      },

      locationSelectionChanged (selectedIds) {
        this.selectedLocationIds = selectedIds
        this.showingLocationList = false
        this.loadVisits()
      },

      providerSelectionChanged (selectedIds) {
        this.selectedProviderIds = selectedIds
        this.showingProviderList = false
        this.loadVisits()
      },
      employerName (employer) {
        return employer.name
      },
      formatBirthDate (dob) {
        return moment(dob).utc().format('MM/DD/YYYY')
      },

      formatAppointmentDate (date) {
        return moment(date).format('MMM Do h:mm a')
      },

      formatEmployer (employer) {
        if (employer) {
          return employer.name
        }
        return 'Unknown'
      },

      goToPatientDetail (patientId) {
        this.$router.push({ name: 'patient-detail', params: { id: patientId } })
      },

      estimateCreated (estimate) {
        this.editEstimate(estimate)
      },

      editEstimate (estimate) {
        this.$router.push({ name: 'patient-estimate', params: { id: estimate.organizationPatientEstimateId } })
      },

      hideEmployerPopover () {
        if (this.employerPopoverShowing) {
          this.$root.$emit('bv::hide::popover')
        }
      },

      loadVisits (silent = false) {
        if (!silent) {
          this.showingLoadingModal = true
        }
        if (this.isLoadingBundles) {
          return
        }
        this.isLoadingBundles = true
        let paramVisitTypes = []
        if (JSON.stringify(this.selectedVisitTypeIds.sort()) !== JSON.stringify(this.allVisitTypeIds.sort())) {
          paramVisitTypes = this.selectedVisitTypeIds
        }
        let paramProviders = []
        if (JSON.stringify(this.selectedProviderIds.sort()) !== JSON.stringify(this.allProviderIds.sort())) {
          paramProviders = this.selectedProviderIds
        }
        let paramLocations = []
        if (JSON.stringify(this.selectedLocationIds.sort()) !== JSON.stringify(this.allLocationIds.sort())) {
          paramLocations = this.selectedLocationIds
        }
        const employerIdsToSend =
          this.selectedEmployerIds.length === 0
            ? this.allEmployerIds
            : this.selectedEmployerIds
        const parameters = {
          searchTerm: this.searchTerm,
          providerIds: paramProviders,
          locationIds: paramLocations,
          employerIds: employerIdsToSend,
          fromDate: this.fromDateTime,
          toDate: this.toDateTime,
          visitTypes: paramVisitTypes,
          pageSize: this.pageSize,
          page: this.currentPage
        }
        api.post('/Dashboard/Visits/Benefits', parameters, { timeout: 180000 }).then(response => {
          this.persistSettings()
          this.candidateVisits = response.data
          this.currentPage = response.data.page
          this.selectedEmployer = response.data.selectedEmployer
          if (response.data.selectedEmployer) {
            this.selectedEmployerId = response.data.selectedEmployer.organizationEmployerId
          }
          this.totalPages = Math.ceil(response.data.totalVisits / this.pageSize)
        }).catch(error => {
          if (!this.$store.canHandleNetworkError(error)) {
            this.$log.error('Error attempting to load appointments: ' + error.message, error)
            this.errors = ['Error loading appointments: ' + error.message]
          }
        }).then(() => {
          // Workaround for https://github.com/bootstrap-vue/bootstrap-vue/issues/1826
          setTimeout(() => {
            this.showingLoadingModal = false
            this.isLoadingBundles = false
          }, 100)
        })
      },
      loadEmployers () {
        this.isLoadingEmployers = true
        api.get('/Dashboard/Employers').then(response => {
          this.employerIds = response.data
          this.employerIds.forEach(employer => {
            this.employerOptions.push({
              text: employer.name,
              value: employer.organizationEmployerId
            })
          })
        }).catch(error => {
          if (!this.$store.canHandleNetworkError(error)) {
            this.$store.logErrorResponse(this.$options.name, 'LoadError', error)
            this.setFromApiErrorResponse(error)
          }
        }).then(() => {
          // Workaround for https://github.com/bootstrap-vue/bootstrap-vue/issues/1826
          setTimeout(() => {
            this.isLoadingEmployers = false
          }, 100)
        })
      },
      persistSettings () {
        const bundleCandidateFilters = {
          fromTime: this.fromTime,
          toTime: this.toTime,
          fromDate: moment(this.fromDate).toISOString(),
          toDate: moment(this.toDate).toISOString(),
          providerIds: this.selectedProviderIds,
          locationIds: this.selectedLocationIds,
          visitTypes: this.selectedVisitTypeIds,
          employerIds: this.selectedEmployerIds
        }
        localStorage.setItem('selectedBundleCandidateFilters', JSON.stringify(bundleCandidateFilters))
      },

      restoreSettings () {
        this.restoringSettings = true
        const settingBundleCandidateString = localStorage.getItem('selectedBundleCandidateFilters')
        if (settingBundleCandidateString) {
          const bundleCandidateFilters = JSON.parse(settingBundleCandidateString)
          if (bundleCandidateFilters.fromTime && bundleCandidateFilters.fromTime !== 'null') {
            this.fromTime = bundleCandidateFilters.fromTime
          }
          if (bundleCandidateFilters.fromDate && bundleCandidateFilters.fromDate !== 'null') {
            this.fromDate = bundleCandidateFilters.fromDate
          }
          if (bundleCandidateFilters.fromTime && bundleCandidateFilters.fromTime !== 'null') {
            this.fromTime = bundleCandidateFilters.fromTime
          }
          if (bundleCandidateFilters.toDate && bundleCandidateFilters.toDate !== 'null') {
            this.toDate = bundleCandidateFilters.toDate
          }
          if (bundleCandidateFilters.toTime && bundleCandidateFilters.toTime !== 'null') {
            this.toTime = bundleCandidateFilters.toTime
          }
          if (bundleCandidateFilters.locationIds) {
            this.selectedLocationIds = bundleCandidateFilters.locationIds
          }
          if (bundleCandidateFilters.visitTypes) {
            this.selectedVisitTypeIds = bundleCandidateFilters.visitTypes
          }
          if (bundleCandidateFilters.providerIds) {
            this.selectedProviderIds = bundleCandidateFilters.providerIds
          }
          if (bundleCandidateFilters.employerIds) {
            this.selectedEmployerIds = bundleCandidateFilters.employerIds
          }
        }
        this.$nextTick(() => {
          this.restoringSettings = false
        })
      }
    },
    created () {
      this.searchDebounceFn = _.debounce(() => {
        if (this.searchTerm === '') {
          this.totalPages = Math.ceil(this.candidateVisits.totalVisits / this.pageSize)
          this.currentPage = 1
        } else {
          this.currentPage = 1
          this.totalPages = 0
        }
        this.loadVisits()
      }, 500)
      this.restoreSettings()
      this.loadEmployers()
      this.loadVisits()
    }
  }
</script>

<style scoped>
.providers-filter {
  margin-left: 8px;
}

.visits-header div {
  padding: 0.75rem;
  vertical-align: bottom;
  border-top: 1px solid #dee2e6;
  border-bottom: 2px solid #dee2e6;
  font-weight: bold;
  border-collapse: collapse;
}

.visit-row .column {
  padding: 0.75rem;
  vertical-align: bottom;
  border-collapse: collapse;
}

.visit-row {
  border-bottom: 1px solid #dee2e6;
  background-color: #f9f9f9;
}

.verification-status-container span.badge {
  font-size: .95rem;
}

svg.danger {
  color: #dc3545;
}

.orange-border {
  border: 1px solid rgb(255, 70, 0);
  border-radius: 5px;
}

.patient-search-border {
  border: 1px solid rgb(255, 70, 0);
  border-radius: 5px;
}

.patient-search {
  border: none;
  border-radius: 4px 0 0 4px;
  box-shadow: none;
  padding-right: 0px;
  min-width: 230px;
}

.patient-search:focus {
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075),
  inset 0 0 1px rgba(255, 70, 0, .6);
}

.patient-search-submit {
  border: none;
  border-radius: 0 4px 4px 0;
}

.patient-search-submit:focus,
.patient-search-submit:focus:active,
.patient-search-submit:active {
  outline: 5px auto rgba(255, 70, 0, 0.1);
}

.patient-search-submit:hover {
  color: rgb(255, 70, 0);
}

.header-row {
  margin-top: 28px;
}

.patient-search {
  min-width: 220px;
  height: 36px;
}

.patient-search-section {
  margin-top: 28px;
}
</style>
